import { lazy } from 'react';

export const PlayerRemoveGlobalLossLimitForm = lazy(
  () => import('./PlayerRemoveGlobalLossLimitForm'),
);
